import { createApi } from '@reduxjs/toolkit/query/react';
import type { PromoCodeData } from 'common/interfaces/promoCode.interface';
import type { ErrorResponse } from 'common/interfaces/error.interface';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';

/** Defining a service using a base URL and expected endpoints  */
export const promoCodeQuery = createApi({
  reducerPath: 'promoCodeQuery',
  tagTypes: ['PromoCode'],
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (build) => ({
    getPromoCode: build.mutation({
      query: ({ code }) => ({
        url: `api/cp/promo-code/${code}`,
        method: 'GET',
      }),
      transformResponse: (response: PromoCodeData) => response,
      transformErrorResponse: (response: ErrorResponse) => response,
    }),
  }),
});

/** Export hooks for usage in functional components, which are auto-generated based on the defined endpoints */
export const { useGetPromoCodeMutation } = promoCodeQuery;
